import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import VeeValidateMessagesRU from 'vee-validate/dist/locale/ru'

import { get, isObject, each, isEmpty } from 'lodash'

Vue.use(VeeValidate)
Validator.localize('ru', VeeValidateMessagesRU)

// Правила валидации
/* eslint-disable-next-line */
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
const rules = {
  // валидаци email на валидность
  email: v => emailRe.test(v) || 'Введен невалидный email',

  // обязательное поле
  required: v => !!v || 'Поле обязательно для заполнения',

  // сравнивает введенные пароли
  passMatch: (v, pass) => v === pass || 'Введенные пароли не совпадают',

  // число
  number: v => isEmpty(v) || !!Number(v) || Number(v) === 0 || 'Введите число'
}

const install = Vue => {
  Vue.prototype.$rules = rules
  Vue.prototype.$showServerErrors = function(error) {
    if (!this.hasOwnProperty('$validator')) return

    let validator = this.$validator
    validator.errors.clear()

    let errors = get(error, 'response.data.errors', false)

    if (!errors) return

    let nextTick
    if (isObject(errors)) {
      // Серверная валидация формы
      nextTick = () =>
        each(errors, (msg, field) => {
          validator.errors.add({
            field,
            msg: msg.join(', ')
          })
        })
    } else {
      // Глобальная ошибка
      this.$root.showSnack(errors)
    }

    this.$nextTick(nextTick)
  }
}

export default install
